import {
    SEND_REGISTRATION,
    SEND_REGISTRATION_SUCCESS,
    SEND_REGISTRATION_AFTER,
    SEND_REGISTRATION_AFTER_SUCCESS,
    SEND_REGISTRATION_AFTER_HATCH,
    SEND_REGISTRATION_AFTER_HATCH_SUCCESS
} from './constants';

/**
 *
 * @param formData
 * @returns {{formData: *, type: string}}
 */
const sendRegistrationForm = ( formData, resp ) => ( {
    type: SEND_REGISTRATION,
    formData,
    resp
} );
/**
 *
 * @param user
 * @returns {{type: string, user: *}}
 */
const sendRegistrationFormSuccess = ( user ) => ( {
    type: SEND_REGISTRATION_SUCCESS,
    user
} );
/**
 *
 * @param formData
 * @returns {{formData: *, type: string}}
 */
const sendRegistrationFormAfter = ( formData, resp ) => ( {
    type: SEND_REGISTRATION_AFTER,
    formData,
    resp
} );
/**
 *
 * @param user
 * @returns {{type: string, user: *}}
 */
const sendRegistrationFormAfterSuccess = ( user ) => ( {
    type: SEND_REGISTRATION_AFTER_SUCCESS,
    user
} );
/**
 *
 * @param formData
 * @returns {{formData: *, type: string}}
 */
const sendRegistrationFormAfterHatch = ( formData ) => ( {
    type: SEND_REGISTRATION_AFTER_HATCH,
    formData
} );
/**
 *
 * @param user
 * @returns {{type: string, user: *}}
 */
const sendRegistrationFormAfterHatchSuccess = ( user ) => ( {
    type: SEND_REGISTRATION_AFTER_HATCH_SUCCESS,
    user
} );

export {
    sendRegistrationForm,
    sendRegistrationFormSuccess,
    sendRegistrationFormAfter,
    sendRegistrationFormAfterSuccess,
    sendRegistrationFormAfterHatch,
    sendRegistrationFormAfterHatchSuccess
};
